import { Alert, AlertTitle } from "@mui/material";
import OutlinedFlagRoundedIcon from "@mui/icons-material/OutlinedFlagRounded";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import ArchiveOutlinedIcon from "@mui/icons-material/ArchiveOutlined";
import { ProjectDetails } from "../../../api/models/ProjectDetails";
import styles from "./ProjectDetailsTab.module.scss";
import { FlaggingReason, FlaggingReasonDisplayInfo } from "../../../../ProjectsList/api/models/FlaggingReason";

interface ProjectDetailsAlertProps {
  project: ProjectDetails;
  billingType: string;
}

export const ProjectDetailsAlert: React.FC<ProjectDetailsAlertProps> = ({
  project,
  billingType,
}) => {
  const isArchived = project?.isArchived ?? false;
  const flaggingReason = project?.flaggingReason
  ? FlaggingReason[project.flaggingReason as keyof typeof FlaggingReason]
  : undefined;
  const { title: alertTitle = '', message: alertMessage = '' } =
  flaggingReason !== undefined ? FlaggingReasonDisplayInfo[flaggingReason] : {};

  return (
    <>
      {!isArchived &&
        project.isFlagged &&
        project.flaggingStatus !== "Locked" &&
        billingType !== "EnterBillingLater" && (
          <Alert
            severity="warning"
            icon={<OutlinedFlagRoundedIcon />}
            className={styles.projectDetails__flaggedAlert}
          >
            <AlertTitle className={styles.projectDetails__flaggedAlertTitle}>
              {alertTitle}
            </AlertTitle>
            {alertMessage}
          </Alert>
        )}

      {!isArchived && project.isFlagged && project.flaggingStatus === "Locked" && (
        <Alert
          severity="error"
          icon={<LockOutlinedIcon />}
          className={styles.projectDetails__flaggedAlert}
        >
          <AlertTitle className={styles.projectDetails__flaggedAlertTitle}>
            {alertTitle}
          </AlertTitle>
          {alertMessage}
        </Alert>
      )}

      {!isArchived &&
        project.isFlagged &&
        project.flaggingStatus !== "Locked" &&
        billingType === "EnterBillingLater" && (
          <Alert
            severity="warning"
            icon={<OutlinedFlagRoundedIcon />}
            className={styles.projectDetails__flaggedAlert}
          >
            <AlertTitle className={styles.projectDetails__flaggedAlertTitle}>
              No billing type entered yet
            </AlertTitle>
            Select a billing type and enter the details.
          </Alert>
        )}

      {isArchived && (
        <Alert
          severity="warning"
          icon={<ArchiveOutlinedIcon />}
          className={styles.projectDetails__flaggedAlert}
        >
          <AlertTitle className={styles.projectDetails__flaggedAlertTitle}>
            Project archived
          </AlertTitle>
          Project is archived, only viewable by admins
        </Alert>
      )}
    </>
  );
};
